import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPulseLibrary = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "pulse_library",
	"data-name": "pulse library",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 21 21",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group_520",
		"data-name": "Group 520",
		transform: "translate(-23 -419)",
		children: [/* @__PURE__ */ _jsxs("g", {
			id: "Rectangle_1246",
			"data-name": "Rectangle 1246",
			transform: "translate(23 419)",
			fill: "none",
			stroke: "#fff",
			strokeWidth: 1,
			children: [/* @__PURE__ */ _jsx("rect", {
				width: 21,
				height: 21,
				stroke: "none"
			}), /* @__PURE__ */ _jsx("rect", {
				x: .5,
				y: .5,
				width: 20,
				height: 20,
				fill: "none"
			})]
		}), /* @__PURE__ */ _jsx("path", {
			id: "Path_286",
			"data-name": "Path 286",
			d: "M-6488.421-1782.322c5.289,0,4.447-10.285,9.943-10.285s4.577,10.285,10.107,10.285",
			transform: "translate(6512 2218)",
			fill: "none",
			stroke: "#fff",
			strokeWidth: 1
		})]
	})
});
export default SvgPulseLibrary;
